import { useEffect } from "react";

const FORMALYS_DOMAIN = "https://formalys.io";

/** Redirects legacy Cloud Run URLs while preserving the current route. */
export const useLegacyDomainRedirect = () => {
  useEffect(() => {
    if (!window.location.hostname.endsWith(".run.app")) return;

    const newUrl =
      FORMALYS_DOMAIN +
      window.location.pathname +
      window.location.search +
      window.location.hash;

    window.location.replace(newUrl);
  }, []);
};

